import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Property } from "@app/models/Property";
import { Router } from "@angular/router";

@Component({
    template: require('./propertySelector.html')
})
export class PropertySelectorComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<PropertySelectorComponent>) public dialogRef: MatDialogRef<PropertySelectorComponent>,
                @Inject(Router) private router: Router) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }

    navigateToPropertyPayments(property: Property) {
        this.router.navigateByUrl('/properties/' + property.id + '/payment',
            { state: { propertyId: property.id, property: property } })
        this.dialogRef.close();
    }
}
